import { useEffect } from 'preact/hooks';

import { usePlayerContainer } from './usePlayerContainer';

export const useKeyboardHandler = (listener: (e: KeyboardEvent) => void) => {
  const playerContainer = usePlayerContainer();

  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.ctrlKey || e.metaKey) {
        return true;
      }

      listener(e);

      if (
        e.code === 'Space' ||
        e.code === 'ArrowLeft' ||
        e.code === 'ArrowRight' ||
        e.code === 'ArrowUp' ||
        e.code === 'ArrowDown'
      ) {
        // Prevent key presses from scrolling the screen.
        e.preventDefault();
      }
    };

    playerContainer.addEventListener('keydown', handler);

    return () => playerContainer.removeEventListener('keydown', handler);
  }, [playerContainer, listener]);
};
